export default "__VITE_ASSET__C1lT6_l6__"